import { BaseEditViewStore } from 'core/stores';
import { NikoTemplateMissingProductNoteModalForm } from 'application/niko-patient/forms';
import { action, observable } from "mobx";
import { NikoPatientTemplateService } from 'application/niko-patient/services';

class NikoTemplateMissingProductNoteModalStore extends BaseEditViewStore {
    @observable accessor disabled = false;
    constructor(rootStore, componentProps) {
        const nikoPatientTemplateService = new NikoPatientTemplateService(rootStore.application.baasic.apiClient);
        const patientTemplate = componentProps.modalParams.data.patientTemplate;
        const showTemplateChangeWarning = componentProps.modalParams.data.showTemplateChangeWarning;
        super(rootStore, {
            name: 'niko-template-missing-product-note-modal',
            Form: NikoTemplateMissingProductNoteModalForm,
            id: patientTemplate.id,
            actions: () => {
                return {
                    get: async () => {
                        return patientTemplate;
                    },
                    update: async () => {
                        await nikoPatientTemplateService.updateMissingProductNote(this.patientTemplate);
                        if (showTemplateChangeWarning){
                            showTemplateChangeWarning();
                        }
                    }
                }
            },
            FormClass: NikoTemplateMissingProductNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.patientTemplate = patientTemplate;
        this.isEditDisabled = Boolean(componentProps.modalParams.data.isEditDisabled);
    }

    @action.bound
    async resolveMissingProductNote() {
        this.disabled = true;
        try {
            this.patientTemplate.missingProductNote = null;
            await this.actions.update();
            this.modalParams.close();
        }
        catch (err) {
            this.disabled = false;
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            this.patientTemplate.missingProductNote = resource.missingProductNote;
            await this.actions.update();
            this.modalParams.close();
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default NikoTemplateMissingProductNoteModalStore;
